import { DataType } from '../../enums';

export const convertToQueriesArray = (queriesString) => {
    let queriesArray = [];
    try {
        let parsedQueries = queriesString;

        // Manual conversion of the string to array
        if (typeof parsedQueries === DataType.STRING) {
            // Remove the outer square brackets and split by comma
            parsedQueries = parsedQueries
                .replace(/^\[|\]$/g, '') // Remove outer square brackets
                .split(/,\s*(?=['"])/) // Split by commas between strings
                .map(
                    (query) => query.replace(/^['"]|['"]$/g, '') // Remove quotes around each query
                );
        }

        // If it's an array, assign it to queriesArray
        if (Array.isArray(parsedQueries)) {
            queriesArray = parsedQueries;
        }
    } catch (error) {
        console.error('Failed to parse queries:', error);
    }

    return queriesArray;
};
